import { appraisalProductApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const APPRAISAL_PRODUCTS_ACTION_TYPE = createNamedActions('appraisalProducts', {
  GET_APPRAISAL_PRODUCTS: 'GET_APPRAISAL_PRODUCTS',
  DELETE_APPRAISAL_PRODUCT: 'DELETE_APPRAISAL_PRODUCT',
  GET_APPRAISAL_PRODUCT_CATALOGS: 'GET_APPRAISAL_PRODUCT_CATALOGS',
  CREATE_APPRAISAL_PRODUCT: 'CREATE_APPRAISAL_PRODUCT',
  UPDATE_APPRAISAL_PRODUCT: 'UPDATE_APPRAISAL_PRODUCT',
});

const appraisalProductsSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getAppraisalProductsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalProductApi.getAppraisalProducts(params);

  return dispatch({
    type: APPRAISAL_PRODUCTS_ACTION_TYPE.GET_APPRAISAL_PRODUCTS,
    payload: normalize(data, [appraisalProductsSchema]).entities.data,
  });
});

export const deleteAppraisalProductAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalProductApi.deleteAppraisalProduct(params);

  return dispatch({
    type: APPRAISAL_PRODUCTS_ACTION_TYPE.DELETE_APPRAISAL_PRODUCT,
    payload: data,
    meta: params,
  });
});

export const getAppraisalProductCatalogsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await appraisalProductApi.getCatalogs();

  return dispatch({
    type: APPRAISAL_PRODUCTS_ACTION_TYPE.GET_APPRAISAL_PRODUCT_CATALOGS,
    payload: data,
  });
});

export const createAppraisalProductAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalProductApi.createAppraisalProduct(params);

  return dispatch({
    type: APPRAISAL_PRODUCTS_ACTION_TYPE.CREATE_APPRAISAL_PRODUCT,
    payload: data,
  });
});

export const updateAppraisalProductAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalProductApi.editAppraisalProduct(params);

  return dispatch({
    type: APPRAISAL_PRODUCTS_ACTION_TYPE.UPDATE_APPRAISAL_PRODUCT,
    payload: data,
  });
});
